// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import './assets/icon/iconfont.css'
// import VueSocket from 'vue-socket.io'

Vue.config.productionTip = false
Vue.use(ElementUI)


// Vue.use(VueSocket, '/endpointWisely');

Vue.filter('to-date', (value) => {
  return new Date(parseInt(value)).toLocaleString().replace(/:\d{1,2}$/, ' ');
})
Vue.filter('to-fixed', (number) => {
  number = String(number)
  let r = number.indexOf('.')
  if (-1 === r) {
    return `${number}.00`
  }
  else {
    let float = number.split('.')[1].length
    if (0 === float) {
      return `${number}00`
    }
    else if (1 === float) {
      return `${number}0`
    }
    else {
      return `${number}`
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js